import imageUrlBuilder from '@sanity/image-url';

export default function (source: any) {
    const config = useRuntimeConfig();

    const builder = imageUrlBuilder({
        projectId: config.public.sanity.projectId,
        dataset: config.public.sanity.dataset,
    });

    return builder.image(source);
}
